import { render, staticRenderFns } from "./FFinvoice.vue?vue&type=template&id=7bfdf1d6"
import script from "./FFinvoice.vue?vue&type=script&lang=js"
export * from "./FFinvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports